// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { RegionalSalesRepApiResponse } from "@stoneage/App/Services/RegionalSalesRep/regionalSalesRepService";
import { Draft } from "immer";

type RegionalSalesRepState = Readonly<{
    isLoading: boolean;
    data?: RegionalSalesRepApiResponse;
}>;

const initialRegionalSalesRepState: RegionalSalesRepState = {
    isLoading: false,
    data: undefined,
};

const reducer = {
    "RegionalSalesRep/StartedLoading": (draft: Draft<RegionalSalesRepState>) => {
        draft.isLoading = true;
    },
    "RegionalSalesRep/ComletedLoading": (
        draft: Draft<RegionalSalesRepState>,
        payload: { data?: RegionalSalesRepApiResponse },
    ) => {
        draft.isLoading = false;
        draft.data = payload.data;
    },
};

const xRegionalSalesRep = createTypedReducerWithImmer(initialRegionalSalesRepState, reducer);

(reducers as any).xRegionalSalesRep = xRegionalSalesRep;

export type xRegionalSalesRepState = {
    xRegionalSalesRep: RegionalSalesRepState;
};

type xRegionalSalesRepReducers = {
    isLoading: typeof xRegionalSalesRep;
    data: typeof xRegionalSalesRep;
};

export type xRegionalSalesRepActions =
    | Parameters<xRegionalSalesRepReducers[keyof xRegionalSalesRepReducers]>[1]
    | AnyAction;
